import { useEffect } from "react";
import { Mail, Download } from "lucide-react";

export default function PressPage() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <main style={ { backgroundColor: "#0b1a14" }}>
      {/* Hero */}
      <header className="relative pt-40 pb-24 px-6 border-b border-white/5">
        <div className="max-w-4xl mx-auto">
          <span className="text-[#C4A77D] text-xs tracking-[0.4em] uppercase">
            Media
          </span>
          <h1
            className="text-5xl md:text-7xl text-white font-light mt-4 leading-tight"
            style={ { fontFamily: "'Playfair Display', serif" }}
          >
            Press & Media
          </h1>
          <p className="mt-6 text-gray-400 text-lg font-light leading-relaxed max-w-2xl">
            For media enquiries, press coverage, and brand assets, please reach
            out to our communications team.
          </p>
        </div>
      </header>

      {/* Press Contact */}
      <section className="py-20 px-6 border-b border-white/5">
        <div className="max-w-4xl mx-auto grid md:grid-cols-2 gap-12">
          <div>
            <span className="text-[#C4A77D] text-xs tracking-[0.3em] uppercase">
              Contact
            </span>
            <h2
              className="text-2xl text-white mt-3 mb-6 font-light"
              style={ { fontFamily: "'Playfair Display', serif" }}
            >
              Media Enquiries
            </h2>
            <p className="text-gray-400 text-sm font-light leading-relaxed mb-8">
              Whether you're writing a feature, producing content, or seeking a
              spokesperson for your publication, our communications team is
              available to assist.
            </p>
            <a
              href="mailto:press@raha-iduu.com"
              className="inline-flex items-center gap-2 px-8 py-3 border border-[#C4A77D] text-[#C4A77D] text-xs uppercase tracking-wider hover:bg-[#C4A77D] hover:text-black transition-all duration-300"
            >
              <Mail className="w-3.5 h-3.5" />
              press@raha-iduu.com
            </a>
          </div>

          <div className="space-y-4">
            {[
              { label: "Company Name", value: "Raha-ídúù Experience Ltd" },
              { label: "Founded", value: "2024" },
              { label: "Headquarters", value: "Lagos, Nigeria" },
              { label: "Locations", value: "Abuja · Lagos · Calabar" },
              { label: "Sector", value: "Luxury Concierge & Lifestyle" },
            ].map(({ label, value }) => (
              <div
                key={label}
                className="flex justify-between items-center py-3 border-b border-white/5"
              >
                <span className="text-gray-500 text-xs tracking-wide uppercase">
                  {label}
                </span>
                <span className="text-gray-300 text-sm font-light">{value}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brand Assets */}
      <section className="py-20 px-6 border-b border-white/5 bg-[#081210]">
        <div className="max-w-4xl mx-auto">
          <span className="text-[#C4A77D] text-xs tracking-[0.3em] uppercase">
            Downloads
          </span>
          <h2
            className="text-2xl text-white mt-3 mb-10 font-light"
            style={ { fontFamily: "'Playfair Display', serif" }}
          >
            Brand Assets
          </h2>
          <div className="grid sm:grid-cols-3 gap-4">
            {[
              { name: "Logo Pack", desc: "SVG & PNG, dark and light variants" },
              { name: "Brand Guidelines", desc: "Colours, typography, and usage rules" },
              { name: "Photography", desc: "High-resolution brand imagery" },
            ].map(({ name, desc }) => (
              <div
                key={name}
                className="p-6 border border-white/10 bg-[#0b1a14] flex flex-col gap-4"
              >
                <div>
                  <p className="text-white text-sm font-light">{name}</p>
                  <p className="text-gray-500 text-xs mt-1 leading-relaxed">{desc}</p>
                </div>
                <a
                  href="mailto:press@raha-iduu.com?subject=Brand Asset Request"
                  className="inline-flex items-center gap-2 text-[#C4A77D] text-xs tracking-wide hover:text-white transition-colors mt-auto"
                >
                  <Download className="w-3.5 h-3.5" />
                  Request via email
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* News placeholder */}
      <section className="py-20 px-6 bg-[#050d09]">
        <div className="max-w-4xl mx-auto text-center">
          <span className="text-[#C4A77D] text-xs tracking-[0.3em] uppercase">
            News
          </span>
          <h2
            className="text-2xl text-white mt-3 mb-4 font-light"
            style={ { fontFamily: "'Playfair Display', serif" }}
          >
            Latest Coverage
          </h2>
          <p className="text-gray-500 text-sm font-light leading-relaxed max-w-md mx-auto mb-10">
            Press coverage and announcements will appear here. For the latest
            news, contact our communications team.
          </p>
          <div className="inline-block px-6 py-2 border border-white/10 text-gray-600 text-xs tracking-widest uppercase">
            Updates coming soon
          </div>
        </div>
      </section>
    </main>
  );
}
